import React from 'react';
import GoogleIcon from '@mui/icons-material/Google';
import { authService } from 'src/services/services/auth/auth.api';
import { ResponseKind } from 'src/services/services/MainService';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../Buttons/CustomButton';

const GoogleButton: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);

    const onClick = async () => {
        try {
            setLoading(true);
            const response = await authService.googleSignup();
            if (response.kind == ResponseKind.OK) {
                const URL = response.data;
                if (typeof URL === 'string') {
                    window.location.href = URL;
                }
            }
        } catch (error) {
            console.error('Google signup error:', error);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center">
            {/* <button
                onClick={onClick}
                className="w-full max-w-sm flex justify-center items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded shadow"
            >
                <GoogleIcon className="text-white" />
                Sign in with Google
            </button> */}
            <CustomButton
                onClick={onClick}
                loading={loading}
                disabled={loading}
                type="button"
                leftIcon={loading ?undefined  : "google"}
            >
                Sign in with Google
            </CustomButton>
        </div>
    );
};

export default GoogleButton;
